<template>
	<div>
    <Form ref="personalForm" :model="userVo" :rules="rules" :label-width="110" >
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="昵称：" prop="nickName">
					<Input v-model="userVo.nickName">
					</Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="邮箱：" prop="email">
					<Input v-model="userVo.email">
					</Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="手机号：" prop="phone">
					<Input v-if="userType==6" v-model="userVo.phone" disabled></Input>
					<Input v-else v-model="userVo.phone"></Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="10">
				<Col span="24">
				<FormItem label="单位名称：" prop="organization">
					<Input v-model="userVo.organization">
					</Input>
				</FormItem>
				</Col>
			</Row>
			<Row :gutter="10" v-if="addressShow">
				<Col span="24">
				<FormItem label="地址：" prop="citys" class="address-select">
					<al-selector level="2" auto v-model="userVo.citys" @on-change="handleOnselectorChange"/>
				</FormItem>
				</Col>
			</Row>
		</Form>
	</div>
</template>

<script>
	var not = /^\s+|\s+$/g;
	var emailReg = /^(\w-*\.*)+@(\w-?)+(\.\w{2,4})+$/;
	var phoneReg = /^[1][0-9]{10}$/;
	                   
	
	export default {
		name: "personal",
		props: ['addressShow', 'userId', 'userType'],
		data() {
			var validateNickName = (rule, value, callback) => {
				if(value == undefined || value == null || value === '') {
					callback(new Error('请填写昵称'));
				} else {
					var nickName = value.toString().replace(not, "");
					this.userVo.nickName = nickName;
					if(nickName == undefined || nickName === '') {
						callback(new Error('请填写昵称'));
					} else if(nickName.length>18){
						callback(new Error('昵称长度不能大于18'));
					} else if(/\s+/.test(nickName)){
						callback(new Error('昵称不能包含空白符'));
					} else {
						callback();
					}
				}
			};
			var validateEmail = (rule, value, callback) => {
				if(value == undefined || value == null || value === '') {
					callback(new Error('请填写邮箱'));
				} else {
					var email = value.toString().replace(not, "");
					this.userVo.email = email;
					if(email == undefined || email === '') {
						callback(new Error('请填写邮箱'));
					} else if(email.length>50){
						callback(new Error('邮箱长度不能大于50'));
					} else if(!emailReg.test(email)){
						callback(new Error('邮箱格式不正确'));
					} else {
						callback();
					}
				}
			};
			var validatePhone = (rule, value, callback) => {
				if(value == undefined || value == null || value === '') {
					callback(new Error('请填写手机号'));
				} else {
					var phone = value.toString().replace(not, "");
					this.userVo.phone = phone;
					if(phone == undefined || phone === '') {
						callback(new Error('请填写手机号'));
					} else if(!phoneReg.test(phone)){
						callback(new Error('手机号格式不正确'));
					} else {
						callback();
					}
				}
			};
			var validateOrganization = (rule, value, callback) => {
				if(value == undefined || value == null || value === '') {
					callback(new Error('请填写单位名称'));
				} else {
					var organization = value.toString().replace(not, "");
					this.userVo.organization = organization;
					if(organization == undefined || organization === '') {
						callback(new Error('请填写单位名称'));
					} else if(organization.length>18){
						callback(new Error('单位名称长度不能大于18'));
					} else {
						callback();
					}
				}
			};
			return {
				userVo:{
					id: 0,
					nickName: '',
					email: '',
					phone: '',
					organization: '',
					address: '',
					citys: ['','','']
				},
				rules: {
					nickName: [{
						required: true,
						validator: validateNickName,
						trigger: 'blur'
					}],
					email: [{
						required: true,
						validator: validateEmail,
						trigger: 'blur'
					}],
					phone: [{
						required: true,
						validator: validatePhone,
						trigger: 'blur'
					}],
					organization: [{
						required: true,
						validator: validateOrganization,
						trigger: 'blur'
					}]
				},
			}
		},
		methods: {
			initData(){
				var uId = sessionStorage.getItem("userId");
				var orgId = sessionStorage.getItem("orgId");
				var orgName = sessionStorage.getItem("orgName");
				console.log("userId：" + uId + "，局点id：" + orgId +"，局点名称：" +orgName);
				console.log(uId == this.userId);
				//获取个人信息，成功时渲染数据并弹出modal
				this.$http.get(this.$apiPrifixUri + "/user/" + this.userId).then(res=>{
					if (res.code == 0) {
						this.userVo.id = this.userId;
						this.userVo.nickName = res.data.nickName;
						this.userVo.email =res.data.email;
						this.userVo.phone = res.data.phone;
						this.userVo.organization = res.data.organization;
						this.userVo.address = res.data.address;
						if(res.data.address!=null && res.data.address!=''){
							var citysDb = res.data.address.split('@@');
							if(citysDb!=undefined && citysDb!=null && citysDb.length==3){
								this.userVo.citys[0] =citysDb[0];
								this.userVo.citys[1] =citysDb[1];
								this.userVo.citys[2] =citysDb[2];
							} else {
								this.userVo.citys=['','',''];
							}
						} else {
							this.userVo.citys=['','',''];
						}
						this.$emit('personalToParent', true);
					} else {
						this.$Message.info(res.message);
					}
				}).catch((error) => {
					this.$Message.error('获取当前用户信息出错！');
				})
			},
			handleOnselectorChange(value){
				if(value.length ==1){
					this.userVo.citys[0]= value[0];
					this.userVo.citys[1] ='';
					this.userVo.citys[2] ='';
				}else if(value.length ==2){
					this.userVo.citys[0] =value[0];
					this.userVo.citys[1] =value[1];
					this.userVo.citys[2] ='';
				}else if(value.length ==3){
					this.userVo.citys[0] =value[0];
					this.userVo.citys[1] =value[1];
					this.userVo.citys[2] =value[2];
				}
			},
			submitForm(){
				this.$refs.personalForm.validate(valid=>{
					if(valid){
						this.userVo.id = this.userId;
						this.userVo.address = this.userVo.citys[0].name+"@@"+this.userVo.citys[1].name+"@@"+this.userVo.citys[2].name;
						this.$http.put(this.$apiPrifixUri + "/user/personal", this.userVo).then(res=>{
							if (res.code == 0) {
								this.$emit('personalToParent', false);
								this.$Message.info("修改个人中心信息成功！");
							}else{
								this.$Message.info(res.message);
							}
						}).catch((error) => {
							this.$Message.error('请求出错！');
						});
					}
				});
			}
		},
		mounted() {
		},
		computed: {
		},
		watch: {
    }
	}
</script>

<style>
  .ivu-input {
		width:95%;
	}
  .address-select .ivu-col-span-8{
    width:31.2%;
  }
</style>


// WEBPACK FOOTER //
// src/components/header/Personal.vue